export enum EnvironmentCode {
  local = 'local',
  dev = 'dev',
  prod = 'prod',
  staging = 'staging'
}

/** The app environment options. */
export interface Environment {
  /** Environment Code */
  production: boolean;

  /** Defines if the environment code. */
  env: EnvironmentCode;

  /** The data provider to use. */
  dataProvider: 'api' | 'mock';

  /** The root URL of the API. */
  apiRootUrl: string;

  /** The report URL of the API. */
  apiReportUrl: string;

  /** The Google Tag Manager UID. */
  gtmUid: string;

  /** The root URL of the login page. */
  passwordChangeRoot: string;

  /** The root URL of the Finstral Cloud. */
  cloudUrl: string;

  /** The product fruit workspace UID. */
  productFruitsWorkspace: string;

  /** The product fruit checklist id. */
  productFruitsChecklistId: number;

  /** The crypto salt key. */
  cryptoSalt: string;
}
